<template>
  <div>

    <!-- Data Stores Hack, need to be loaded first -->
    <ShiftStore ref="shiftStore"/>
    <!-- ///////////////////////////////////////// -->

    <h1>Shifts - Summary</h1>
    <div>

      <!-- <span style="float:left;">Select Date:</span> <DatePicker style="float:left;"/> -->
      <span style="float:left;">Select Date:</span> 
      <!-- <GenericDaySelector storeName="shiftStore" style="float:left;"/> -->
      <GenericDatePeriodSelector storeName="shiftStore" dateKey="week" />
      <GenericDaysSelector storeName="shiftStore" />
    </div>
    <br style="clear:both;" />
    
    
    <ExportToExcel 
      :tables="['RCGB', 'RMGB', 'WGB']" 
      bookName="Shift Summary"
      storeName="shiftStore"
    />

    <div v-for="location in $locations" :key="location">
      <ShiftSummaryTable 
        :location="location" 
        :showDataEntry="false" 
        :showTransCounts="ls.showTransCounts" 
        :numOfShifts="ls.numOfShifts" 
      />
    </div>
  </div>
</template>

<script>
import ShiftSummaryTable from '@/pages/Reports/Shifts/Components/ShiftSummaryTable.vue'
import DatePicker from '@/pages/Reports/Shifts/Components/DatePicker.vue'
import ShiftStore from '@/pages/Reports/Shifts/Stores/ShiftStore.vue'
import localstorageMixin from '@/mixins/localstorageMixin.js'

export default {
  mixins: [localstorageMixin],
  components : {DatePicker, ShiftSummaryTable, ShiftStore},
  name: 'ShiftsSummaryPage',
  provide() {
    return {
      shiftsPage: this,
      page: this,
    }
  },
  data () { return { 
    ls: {
      day: '2020-08-01',
      showDataEntry: false,
      showTransCounts: false,
      numOfShifts: 10,
    },
    } 
  },

}
</script>